module.exports = __webpack_public_path__ + "media/videoBG.0e07bb3f.mp4";